<script setup lang="ts">
import { ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import DetailedJobInfoDescListItem from '@/components/items/DetailedJobInfoDescListItem.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  text?: string | null;
}
const props = withDefaults(defineProps<Props>(), {
  text: undefined,
});

const isShowMore = ref(true);

function handleToggleMoreClick(): void {
  isShowMore.value = !isShowMore.value;
}
</script>

<template>
  <dl
    :class="$style.jobInstructionsDescList"
    data-testid="jobInstructionsDescList"
  >
    <DetailedJobInfoDescListItem :class="$style.item" term="Instructions">
      <template v-if="props.text">
        <div :class="$style.description">
          <!-- eslint-disable vue/no-v-html -->
          <div :class="[$style.text, { [$style.textMore]: !isShowMore }]">
            <span
              v-html="props.text.replace(/(?:\r\n|\r|\n)/g, '<br />')"
            ></span>
            <div v-if="!isShowMore"><br /><br /></div>
          </div>
          <!-- eslint-enable vue/no-v-html -->
          <KBtn
            :class="$style.btn"
            variant="text"
            size="xs"
            @click="handleToggleMoreClick"
          >
            Show {{ isShowMore ? 'more' : 'less' }}
          </KBtn>
        </div>
      </template>
      <template v-else>{{ commonConstants.EM_DASH }}</template>
    </DetailedJobInfoDescListItem>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use 'sass:math';
@use '@/styles/colors';
@use '@/styles/variables';

.jobInstructionsDescList {
  line-height: 1.4;
  font-size: 16px;
  margin: 0;
}
  .item {
  }
    .description {
      text-align: right;
    }
      .text {
        text-align: left;
        height: 38.376px;
        overflow: hidden;
      }
      .textMore {
        min-height: 38.376px;
        height: auto;
        overflow: auto;
      }
      .btn {
        text-transform: none;
      }
</style>
